import styled, { css } from 'styled-components';
import { Tooltip } from 'reakit';

export const ReakitTooltip = styled(Tooltip)`
  position: relative;
  z-index: 3;
`;
export const VirtiTooltip = styled.div`
  ${({ theme }) => css`
    padding: 0.6rem 1rem;
    color: ${theme.color.contrast.primary};
    background-color: ${theme.color.primary};
    border-radius: ${theme.borderRadius.md};
  `}
`;
